module.exports = __webpack_public_path__ + "static/media/popin-logo-horizontal.feb6269b.svg";